// const testGroups = JSON.parse(localStorage.getItem("abconvert-experiment-to-group-index"));
// const productIdValue = document.querySelector('product-info').dataset.productId;
// const variantIdValue = document.querySelector('form input[name="id"]').value;
// const experimentId = window.abconvertPriceCartTransformTestDict?.[productIdValue]?.experimentId;
// const userGroupIndex = testGroups?.[experimentId]; // e.g. 0 or 1

// const priceData = window.abconvertPriceCartTransformTestDict?.[productIdValue]?.variantToGroupIndexToPrice?.[variantIdValue]?.[userGroupIndex];

// const isAbTestRunning =
//   testGroups != null &&
//   typeof userGroupIndex === "number" &&
//   priceData != null;

// if (isAbTestRunning) {
//   // Shopify data-price expects price in cents (e.g. 259 → 25900)
//   const priceInCents = Math.round(Number(priceData.price) * 100);
//   const buyPriceEl = document.querySelector("product-buy-price[data-price]");
//   if (buyPriceEl) {
//     buyPriceEl.setAttribute("data-price", priceInCents);
//   }
// }


const testGroups = JSON.parse(localStorage.getItem("abconvert-experiment-to-group-index"));
const dict = window.abconvertPriceCartTransformTestDict;

function getAbPrice(productId, variantId) {
  const experimentId = dict?.[productId]?.experimentId;
  const groupIndex = testGroups?.[experimentId];
  if (testGroups == null || typeof groupIndex !== "number") return null;
  return dict[productId]?.variantToGroupIndexToPrice?.[variantId]?.[groupIndex];
}

function applyAbPrice(el, priceInCents) {
  el.setAttribute("data-price", priceInCents);
  if (el.hasAttribute("data-test-price")) {
    el.setAttribute("data-test-price", priceInCents);
  }
}

// 1. Main product (inside product-info)
const productInfoEl = document.querySelector("product-info");
if (productInfoEl) {
  const productId = productInfoEl.dataset.productId;
  const variantId = productInfoEl.querySelector('form input[name="id"]')?.value;
  const priceData = getAbPrice(productId, variantId);
  if (priceData) {
    const priceInCents = Math.round(Number(priceData.price) * 100);
    const buyPriceEl = productInfoEl.querySelector("product-buy-price[data-price]");
    if (buyPriceEl) applyAbPrice(buyPriceEl, priceInCents);

    console.log(`Applied AB test price for main product ${productId}, variant ${variantId}: ${priceData.price}`);
  }
}

// 2. Bundle products — apply AB price to a single bundle variant element
const bundleComponent = document.querySelector("product-bundle");

function applyAbPriceToBundleVariant(bundleEl) {
  const productId = bundleEl.dataset.productId;
  const variantId = bundleEl.dataset.variantId;
  if (!productId || !variantId) return;
  const priceData = getAbPrice(productId, variantId);
  if (priceData) {
    const priceInCents = Math.round(Number(priceData.price) * 100);
    const priceEl = bundleEl.querySelector("[data-price]");
    if (priceEl) applyAbPrice(priceEl, priceInCents);
  }
}

function recalcBundleTotal() {
  if (bundleComponent) {
    bundleComponent.updateTotal();
    bundleComponent.updateTotalWithCurrency();
  }
}

// Apply to already-rendered bundle variants
document.querySelectorAll("[data-product-bundle-variant][data-product-id][data-variant-id]").forEach(applyAbPriceToBundleVariant);
recalcBundleTotal();

// Watch for dynamically added bundle variants (e.g. user clicks "Add to bundle")
const bundleContainer = bundleComponent?.querySelector(".product-bundle__body");
if (bundleContainer) {
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "data-variant-id") {
        applyAbPriceToBundleVariant(mutation.target);
        recalcBundleTotal();
      }
    }
  }).observe(bundleContainer, { attributes: true, attributeFilter: ["data-variant-id"], subtree: true });
}


// 3. Product bundle recommendations (checkbox inputs in "Upgrade your experience")
document.querySelectorAll('input[name="bundles"][data-product-id]').forEach((input) => {
  const productId = input.dataset.productId;
  const variantId = input.value;
  const priceData = getAbPrice(productId, variantId);
  if (priceData) {
    const priceInCents = Math.round(Number(priceData.price) * 100);
    input.setAttribute("data-price", priceInCents);
    // Update the displayed price text
    const label = input.closest("label");
    const priceEl = label?.querySelector(".price__regular");
    if (priceEl) {
      priceEl.textContent = theme.Currency.formatMoney(priceInCents, theme.settings.moneyFormat);
    }
  }
});